import { commonTypes } from '../common';

const types = {
  SET_NEW_COLOR_AND_STORAGE: 'APISNEEDS/SET_NEW_COLOR_AND_STORAGE',
};

export const initialState = {
  deviceInfo: {
    color: null,
    colorId: null,
    storage: null,
    storageId: null,
    fundingOfferInfo: null,
    imageUrl: null,
    name: null,
    pacPrice: null,
    mobileInsurance: null,
    fileUrl: null,
  },
};

const ApisNeedsTerminalDataReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_TERMINAL_INFO: {
      const {
        name, fundingOfferInfo, imageUrl, color, storage, clientPrice, pvpUntaxed, tradeIn, fileUrl, swap, isPrePurchase, swapRenewalPeriod,
      } = action.payload;

      return {
        ...state,
        deviceInfo: {
          ...state.deviceInfo,
          name,
          fundingOfferInfo,
          imageUrl: `https://www.movistar.es${imageUrl}`,
          color,
          storage,
          pacPrice: clientPrice,
          pvpUntaxed,
          tradeIn,
          fileUrl,
          swap,
          isPrePurchase,
          swapRenewalPeriod,
        },
      };
    }
    case types.SET_NEW_COLOR_AND_STORAGE:
    case commonTypes.SET_OFFER_INFO: {
      const {
        storageId,
        colorId,
      } = action.payload;

      return {
        ...state,
        deviceInfo: {
          ...state.deviceInfo,
          colorId,
          storageId,
        },
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setNewColorAndStorage: ({ colorId, storageId }) => ({
    type: types.SET_NEW_COLOR_AND_STORAGE,
    payload: {
      colorId,
      storageId,
    },
  }),
};

export default ApisNeedsTerminalDataReducer;
